interface PhoneWithHandSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PhoneWithHandSVG = ({ color, style }: PhoneWithHandSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <g clipPath="url(#clip0_535_19002)">
      <path
        d="M10.7993 36.9258H3.6827C1.9821 36.9258 0.606445 35.5501 0.606445 33.8495V3.4444C0.606445 1.87378 1.87378 0.606445 3.4444 0.606445H19.5839C21.1545 0.606445 22.4327 1.88461 22.4327 3.45523V21.3279"
        stroke={color}
        strokeWidth="1.21317"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.40161 0.606445V2.03625C6.40161 2.91364 7.11652 3.61771 7.98307 3.61771H15.0455C15.9228 3.61771 16.6269 2.90281 16.6269 2.03625V0.606445"
        stroke={color}
        strokeWidth="1.21317"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.531 32.6362C28.531 32.6362 28.466 35.1709 27.3178 37.2506C25.7905 40.0452 24.2849 42.1466 24.2849 45.6453"
        stroke={color}
        strokeWidth="1.21317"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.5196 28.5857C22.6387 24.9354 22.8337 23.993 22.0646 23.4622C21.1872 22.8665 20.3099 23.603 19.6274 24.2746"
        stroke={color}
        strokeWidth="1.21317"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.5305 30.3508C25.6497 26.7005 25.8447 25.7581 25.0756 25.2274C24.1982 24.6316 23.3208 25.3682 22.6384 26.0397"
        stroke={color}
        strokeWidth="1.21317"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.531 32.6365C28.6502 28.9861 28.8452 28.0438 28.0761 27.513C27.1987 26.9172 26.3213 27.6538 25.6389 28.3254"
        stroke={color}
        strokeWidth="1.21317"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.7959 49.4041V46.7611C11.7959 46.1545 12.2942 45.6562 12.9008 45.6562H25.1841C25.7907 45.6562 26.289 46.1545 26.289 46.7611V49.4041"
        stroke={color}
        strokeWidth="1.21317"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.9406 45.6455V42.006C13.9406 36.3625 12.3483 34.7269 10.3444 32.3114C10.3444 32.3114 8.9471 30.405 9.10958 28.217C9.2504 26.3322 11.9475 26.1156 12.3591 27.957C12.4025 28.1303 12.4241 28.3145 12.4458 28.5203C12.5216 29.4735 13.0632 30.3184 13.9081 30.7516C15.0021 31.3041 16.2911 30.5025 16.2911 29.2785V18.4141C16.2911 17.5692 16.9735 16.876 17.8293 16.876C18.6741 16.876 19.3674 17.5584 19.3674 18.4141V27.4912"
        stroke={color}
        strokeWidth="1.21317"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_535_19002">
        <rect width="49.7725" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PhoneWithHandSVG;
